module.exports = "/assets/7ad3bbd75d35ae7ac035d58521fe7d75.png";


//////////////////
// WEBPACK FOOTER
// ./src/app/modules/flights/assets/logos-small/2F.png
// module id = 2112
// module chunks = 0